//
// Module for the Security Administration User Detail view.
//
rs.module("content/security/administration/users/userdetail",

    [
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (eventBanner, visibility) {

        // Initialize the module
        function initialize(jsSelectors) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var userTypeRadioContainer = criteria.js(jsSelectors.userTypeRadioContainer, { required: false });
            var domainInput = criteria.js(jsSelectors.domainInput, { required: false });
            var displayNameInput = criteria.js(jsSelectors.displayNameInput);
            var userNameInput = criteria.js(jsSelectors.userNameInput);
            var firstnameInput = criteria.js(jsSelectors.firstnameInput);
            var lastnameInput = criteria.js(jsSelectors.lastnameInput);
            var emailAddressInput = criteria.js(jsSelectors.emailAddressInput);
            var dontExpirePasswordCheckbox = criteria.js(jsSelectors.dontExpirePasswordCheckbox);

            var changeUsernameCheckbox = criteria.js(jsSelectors.changeUsernameCheckbox, { required: false });
            var newUsernameContainer = criteria.js(jsSelectors.newUsernameContainer, { required: false });
            var relinkAccountContainer = criteria.js(jsSelectors.relinkAccountContainer, { required: false });

            var changePasswordCheckbox = criteria.js(jsSelectors.changePasswordCheckbox, { required: false });
            var passwordContainer = criteria.js(jsSelectors.passwordContainer);
            var passwordInput = criteria.js(jsSelectors.passwordInput);
            var confirmPasswordInput = criteria.js(jsSelectors.confirmPasswordInput);

            // Register click event for domain/local radio buttons to enable/disable input controls
            userTypeRadioContainer.find("input").on("click", onUserTypeToggle);

            // Register new username events
            changeUsernameCheckbox.change(function () { toggleChangeUsernameFields($(this).is(':checked')); });

            // Register password events.
            changePasswordCheckbox.change(function () { togglePasswordFields($(this).is(':checked')); });

            // Toggle change username fields according to 'visible'.
            function toggleChangeUsernameFields(visible) {

                visibility.setVisible(newUsernameContainer, visible);

                // relinked container only for domain users.
                if (relinkAccountContainer) {
                    visibility.setVisible(relinkAccountContainer, visible);
                }

                // If hiding, reset fields
                if (!visible) {
                    newUsernameContainer.find("input").val('').clearErrors();
                    if (relinkAccountContainer) {
                        relinkAccountContainer.find("input").prop('checked', false);
                    }
                }
            }

            // Toggle password fields according to 'visible'.
            function togglePasswordFields(visible) {
                visibility.setVisible(passwordContainer, visible);

                if (!visible) {
                    passwordContainer.find("input").val('').clearErrors();
                }
            }

            // Handle the user type toggle event.
            function onUserTypeToggle() {

                // Reset fields.
                resetFields();
                var isDomainUser = userTypeRadioContainer.find("input:checked").val() == "true";

                // Enable or disable fields depending on radio button.
                domainInput.prop('disabled', !isDomainUser);

                [
                    passwordInput,
                    confirmPasswordInput,
                    firstnameInput,
                    lastnameInput,
                    emailAddressInput,
                    dontExpirePasswordCheckbox
                ].forEach((input) => input.prop('disabled', isDomainUser));
            }

            // Clear and fields
            function resetFields() {

                // Clear just errors
                [
                    displayNameInput,
                    userNameInput
                ].forEach((input) => input.clearErrors());

                // Clear both errors and fields
                [
                    domainInput,
                    passwordInput,
                    confirmPasswordInput,
                    firstnameInput,
                    lastnameInput,
                    emailAddressInput
                ].forEach((input) => input.val('').clearErrors());

                // Domain User passwords are not controlled here, so checking the field will do nothing for them.
                // However, this field's default is true for local users, so we reset it here.
                dontExpirePasswordCheckbox.prop('checked', true);

                eventBanner.removeErrorMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);